import { Component,  ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NbGlobalPhysicalPosition, NbMediaBreakpointsService, NbMenuService, NbPopoverDirective, NbSidebarService, NbThemeService, NbToastrService } from '@nebular/theme';

import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { AuthService } from '../../../services/auth.service';
import { AppNotification, NotificationService } from '../../../services/notification.service';
import {
  deleteDoc,
  doc,
  Firestore,
  getDoc,
} from '@angular/fire/firestore';

import { GlobalDataCacheService } from '../../../services/global-data-cache.service';



type SearchResultType =
  | 'job'
  | 'quotation';



interface SearchCategory {
  key: 'all' | SearchResultType;
  label: string;
  icon: string;
}

interface SearchMetric {
  label: string;
  value: string;
  tone?: 'danger' | 'success' | 'primary' | 'warning';
}

interface SearchDetail {
  label: string;
  value: string;
  icon: string;
}

interface SearchActivity {
  title: string;
  description: string;
  date: string;
}

interface GlobalSearchResult {
  id: string;
  sourceId: string;
  type: SearchResultType;

  

  icon: string;
  initials: string;

  title: string;
  subtitle: string;

  status?: string;
  matchedField: string;

  meta: string[];
  metrics: SearchMetric[];
  details: SearchDetail[];
  activities: SearchActivity[];

  primaryActionLabel: string;
  route?: string;
}

interface QuickSearchAction {
  id: string;
  title: string;
  description: string;
  icon: string;
  tone: string;
  route: string;
}

interface SearchResultGroup {
  type: SearchResultType;
  label: string;
  icon: string;
  items: GlobalSearchResult[];
}

interface LocalSearchMatch {
  id: string;
  data: Record<string, any>;
  score: number;
}

interface JobLedgerInvoice {
  identity: string;
  invoiceNumber: string;
  type: 'receivable' | 'payable';
  currency: string;
  total: number;
  balance: number;
  hblNumber: string;
  mblNumber: string;
  partyName: string;
}

interface CurrencyFinancialTotals {
  totalReceivable: number;
  receivableBalance: number;

  totalPayable: number;
  payableBalance: number;

  netBalance: number;
}

interface JobLedgerSummary {
  invoices: JobLedgerInvoice[];

  invoiceNumbers: string[];

  totalInvoiceCount: number;
  receivableInvoiceCount: number;
  payableInvoiceCount: number;

  currencyTotals:
    Record<string, CurrencyFinancialTotals>;
}

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {


  private destroy$ = new Subject<void>();
@ViewChild(NbPopoverDirective) nbPopoverDirective!: NbPopoverDirective;

  userPictureOnly = false;
  user: any;
  profileData: Record<string, any> = {};

  themes = [
    { value: 'default', name: 'Light' },
    { value: 'dark', name: 'Dark' },
    { value: 'cosmic', name: 'Cosmic' },
    { value: 'corporate', name: 'Corporate' },
  ];
    notifications: AppNotification[] = [];
  groupedNotifications: { label: string; items: AppNotification[] }[] = [];
  unreadCount = 0;
originalData: any[] = [];
filteredData: any[] = [];
  currentTheme = 'default';
  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
private profileSub!: Subscription;


@ViewChild('globalSearchInput')
globalSearchInput?: ElementRef<HTMLInputElement>;

globalSearchOpen = false;
searchLoading = false;
searchQuery = '';

activeSearchCategory: 'all' | SearchResultType = 'all';

selectedSearchResult: GlobalSearchResult | null = null;



readonly skeletonRows = [1, 2, 3, 4, 5];

readonly searchCategories: SearchCategory[] = [
  {
    key: 'all',
    label: 'All',
    icon: 'grid-outline',
  },
  {
    key: 'job',
    label: 'Jobs',
    icon: 'briefcase-outline',
  },
  {
    key: 'quotation',
    label: 'Quotations',
    icon: 'file-text-outline',
  },
];

recentSearches: string[] = [];

private readonly recentSearchStorageKey =
  'portus_global_recent_searches';

private readonly maximumRecentSearches = 8;

readonly quickActions: QuickSearchAction[] = [
  {
    id: 'create-quotation',
    title: 'New Quotation',
    description: 'Create a customer quotation',
    icon: 'file-add-outline',
    tone: 'tone-blue',
    route: '/pages/quotation',
  },
  {
    id: 'create-job',
    title: 'Open Jobs',
    description: 'View and manage shipments',
    icon: 'briefcase-outline',
    tone: 'tone-teal',
    route: '/pages/operations/view-bls',
  },

];

globalSearchResults: GlobalSearchResult[] = [];

private searchDebounceTimer?: ReturnType<typeof setTimeout>;
private searchRequestId = 0;

readonly minimumSearchLength = 2;
readonly maximumSearchResults = 10;


private lastExecutedSearchTerm = '';


private readonly entityNameCache =
  new Map<string, string>();

private readonly userNameCache =
  new Map<string, string>();

private readonly jobLedgerSummaryCache =
  new Map<string, JobLedgerSummary>();
  /**
   * Global-search name caches.
   *
   * Quotation documents store customer/shipper/consignee/salesperson as IDs.
   * We resolve only the IDs present in returned quotation results, then cache
   * them. This avoids loading complete entities/users collections and keeps
   * Firestore reads controlled.
   */
  

  /**
   * Voucher account-name cache. Account IDs are resolved only when a returned
   * voucher has no stored label/name, then reused by later searches.
   */
  

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,

    private breakpointService: NbMediaBreakpointsService,
    private authService: NbAuthService,
    private router: Router,

    private authProfileService: AuthService,
    private notifService: NotificationService,
    private firestore: Firestore,
    private toastr: NbToastrService,
    private globalDataCache: GlobalDataCacheService,

  ) {
    // Menu actions handle
    this.menuService
      .onItemClick()
      .pipe(
        takeUntil(this.destroy$),
        map(({ item }) => item.title),
        filter(title => title === 'Log out' || title === 'Profile')
      )
      .subscribe(title => {
        if (title === 'Log out') this.logout();
        if (title === 'Profile') this.router.navigate(['/pages/profile']);
      });
      this.filteredData = [...this.originalData];

      // this.searchService.onSearchSubmit().subscribe((data: any) => {
      //   if (data.tag === 'main-search') {
      //     this.applySearch(data.term);
      //   }
      // });
  }
openEmail() {
  this.router.navigate(['/pages/extra-components/chat']);
  }
  async ngOnInit() {

     this.loadRecentSearches();
    // Sidebar compact on navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.sidebarService.compact('menu-sidebar');
      }
    });

    // Current theme
    this.currentTheme = this.themeService.currentTheme;
 // ✅ 1) Load the profile first
  this.profileSub = this.authProfileService
    .getCurrentUserProfile()
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: any) => {

      if (!data || !data.uid) return;

      this.profileData = data;

      // 🛑 Once the profile is available, do not run again
      this.profileSub.unsubscribe();

      // ✅ 2) Now listen for notifications (profile ready)
      this.notifService.listenForNotifications(
        data.uid,
        data.department
      );

      // ✅ 3) Notification stream (after the profile loads)
      this.notifService.notifications$
        .pipe(takeUntil(this.destroy$))
        .subscribe((list) => {

          const dept = (this.profileData?.department || '').toLowerCase().trim();
          const role = (this.profileData?.role || '').toLowerCase().trim();

          const isExportManager =
            (dept === 'export-depart' || dept === 'export depart') &&
            role === 'manager';

          this.notifications = isExportManager
            ? (list || []).filter(n => n?.type === 'exportInfo')
            : list || [];

          this.unreadCount = this.notifications.filter(n => !n.read).length;
          this.buildNotificationGroups();
        });

      // 🔔 Toast + sound (profile-safe)
      this.notifService.newNotification$
        .pipe(takeUntil(this.destroy$))
        .subscribe((n) => {

          const dept = (this.profileData?.department || '').toLowerCase().trim();
          const role = (this.profileData?.role || '').toLowerCase().trim();

          const isExportManager =
            (dept === 'export-depart' || dept === 'export depart') &&
            role === 'manager';

          if (isExportManager && n?.type !== 'exportInfo') return;

          this.showNotificationToast(n);
          this.playNotificationSound();
        });

    });


    // Load user info

    // Responsive user picture
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(isLessThanXl => (this.userPictureOnly = isLessThanXl));

    // Theme change
    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe(themeName => (this.currentTheme = themeName));


  }
   // 🔹 Toast show
  private showNotificationToast(n: AppNotification) {
    this.toastr.show(
      n.message,
      n.title,
      {
        status: 'info',
        icon: 'bell-outline',
        duration: 4000,
position: NbGlobalPhysicalPosition.TOP_RIGHT,
      }
    );
  }

  // 🔹 Sound play (optional)
  private playNotificationSound() {
    try {
      const audio = new Audio('assets/sounds/notify.mp3');
      audio.play().catch(() => {});
    } catch {}
  }

  // 🔹 Group by date (Today / Yesterday / Older)
  private buildNotificationGroups() {
    const groups: { [label: string]: AppNotification[] } = {};

    this.notifications.forEach((n) => {
      const label = this.getDateLabel(n.createdAt);
      if (!groups[label]) groups[label] = [];
      groups[label].push(n);
    });

    this.groupedNotifications = Object.keys(groups).map((label) => ({
      label,
      items: groups[label],
    }));
  }

  private getDateLabel(ts: any): string {
    const d: Date = ts?.toDate ? ts.toDate() : new Date(ts);
    const today = new Date();
    const yday = new Date();
    yday.setDate(today.getDate() - 1);

    const isSameDate = (d1: Date, d2: Date) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDate(d, today)) return 'Today';
    if (isSameDate(d, yday)) return 'Yesterday';
    return d.toLocaleDateString();
  }

  async openNotification(n: AppNotification) {
    try {
      const ref = doc(this.firestore, `notifications/${n.id}`);
      await deleteDoc(ref);

      this.notifications = this.notifications.filter((item) => item.id !== n.id);
      this.unreadCount = this.notifications.filter((item) => !item.read).length;
      this.buildNotificationGroups();

      this.nbPopoverDirective?.hide?.();

      if (n.quotationId) {
        this.router.navigate(['/pages/quotation/'], {
          queryParams: {
            id: n.quotationId,
            step: 0,
          },
        });
      }
    } catch (err) {
      console.error('Error removing notification:', err);
    }
  }

  goToNotifications() {
    this.nbPopoverDirective?.hide?.();
    this.router.navigate(['/pages/operations/notifications']);
  }



ngOnDestroy(): void {
  document.body.classList.remove(
    'portus-global-search-open'
  );

  this.searchRequestId++;

  if (this.searchDebounceTimer) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = undefined;
  }

  this.destroy$.next();
  this.destroy$.complete();
}

  // Network status





  // Menu actions
  onMenuItemClick(item: any) {
    if (item.title === 'Log out') this.logout();
    if (item.title === 'Profile') this.router.navigate(['/pages/profile']);
  }

  logout() {
    this.authService.logout('email').subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    // this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }


  // Search Bar //

    get filteredSearchResults(): GlobalSearchResult[] {
      if (this.activeSearchCategory === 'all') {
        return this.globalSearchResults;
      }

      return this.globalSearchResults.filter(
        result => result.type === this.activeSearchCategory
      );
    }

get groupedSearchResults(): SearchResultGroup[] {
  const results =
    this.filteredSearchResults;

  return [
    {
      type: 'job',
      label: 'Jobs',
      icon: 'briefcase-outline',
      items: results.filter(
        result =>
          result.type === 'job'
      ),
    },
    {
      type: 'quotation',
      label: 'Quotations',
      icon: 'file-text-outline',
      items: results.filter(
        result =>
          result.type === 'quotation'
      ),
    },
  ];
}

    openGlobalSearch(): void {
      this.globalSearchOpen = true;
      this.searchLoading = false;
      this.searchQuery = '';
      this.globalSearchResults = [];
      this.selectedSearchResult = null;
      this.lastExecutedSearchTerm = '';

      document.body.classList.add('portus-global-search-open');

      setTimeout(() => {
        const input = this.globalSearchInput?.nativeElement;

        if (input) {
          input.value = '';
          input.focus();
        }
      });
    }

closeGlobalSearch(): void {
  this.globalSearchOpen = false;
  this.searchLoading = false;
  this.searchRequestId++;

  if (this.searchDebounceTimer) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = undefined;
  }

  this.globalSearchResults = [];
  this.selectedSearchResult = null;

  document.body.classList.remove(
    'portus-global-search-open'
  );
}


clearGlobalSearch(): void {
  this.searchQuery = '';
  this.activeSearchCategory = 'all';
  this.globalSearchResults = [];
  this.selectedSearchResult = null;
  this.searchLoading = false;
  this.searchRequestId++;
  this.lastExecutedSearchTerm = '';

  if (this.searchDebounceTimer) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = undefined;
  }

  const input = this.globalSearchInput?.nativeElement;

  if (input) {
    input.value = '';
    input.focus();
  }
}
onGlobalSearchInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  this.searchQuery = input.value || '';

  if (this.searchDebounceTimer) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = undefined;
  }

  const rawTerm = this.searchQuery.trim();

  const normalizedTerm =
    this.normalizeSearchTerm(rawTerm);

  if (
    normalizedTerm.length <
    this.minimumSearchLength
  ) {
    this.searchRequestId++;

    this.globalSearchResults = [];
    this.selectedSearchResult = null;
    this.searchLoading = false;
    this.lastExecutedSearchTerm = '';

    return;
  }

  /*
   * Local cached search hai.
   * Small debounce UI ko smooth rakhega.
   */
  this.searchLoading = true;

  this.searchDebounceTimer = setTimeout(() => {
    void this.searchFirebase(
      rawTerm,
      normalizedTerm
    );
  }, 180);
}

private normalizeSearchTerm(value: unknown): string {
  return String(value ?? '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9@._/\-\s]/g, '')
    .replace(/\s+/g, ' ');
}

private normalizeFinancialKey(
  value: unknown
): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}


private async searchFirebase(
  rawTerm: string,
  normalizedTerm: string
): Promise<void> {
  const requestId =
    ++this.searchRequestId;

  try {
    if (!normalizedTerm) {
      this.globalSearchResults = [];
      this.selectedSearchResult = null;
      return;
    }

    await this.globalDataCache
      .loadHeaderCategoryOnce(
        this.activeSearchCategory
      );

    if (
      requestId !==
      this.searchRequestId
    ) {
      return;
    }

    if (
  this.activeSearchCategory === 'all' ||
  this.activeSearchCategory === 'job'
) {
  this.buildJobLedgerSummaryCache();
}

    const isAll =
      this.activeSearchCategory ===
      'all';

    const jobMatches =
      isAll ||
      this.activeSearchCategory ===
        'job'
        ? this.searchLocalCollection(
            this.globalDataCache.jobs,
            normalizedTerm,
            'job'
          )
        : [];

    const quotationMatches =
      isAll ||
      this.activeSearchCategory ===
        'quotation'
        ? this.searchLocalCollection(
            this.globalDataCache
              .quotations,
            normalizedTerm,
            'quotation'
          )
        : [];

    await this.primeQuotationLookupNames(
  quotationMatches.map(
    match => match.data
  )
);

if (
  requestId !==
  this.searchRequestId
) {
  return;
}

    const jobResults =
      jobMatches
        .map(match =>
          this.mapJobResult(
            match.id,
            match.data
          )
        )
        .filter(
          (
            item
          ): item is GlobalSearchResult =>
            item !== null
        );

    const quotationResults =
      quotationMatches
        .map(match =>
          this.mapQuotationResult(
            match.id,
            match.data
          )
        )
        .filter(
          (
            item
          ): item is GlobalSearchResult =>
            item !== null
        );

    const resultLimit =
      this.activeSearchCategory ===
      'all'
        ? 40
        : 25;

    this.globalSearchResults = [
      ...jobResults,
      ...quotationResults,
    ].slice(0, resultLimit);

    this.lastExecutedSearchTerm =
      normalizedTerm;

    this.selectedSearchResult =
      this.globalSearchResults[0] ||
      null;

    if (
      this.globalSearchResults.length
    ) {
      this.saveRecentSearch(rawTerm);
    }
  } catch (error) {
    if (
      requestId !==
      this.searchRequestId
    ) {
      return;
    }

    console.error(
      'Global cached search error:',
      error
    );

    this.globalSearchResults = [];
    this.selectedSearchResult = null;

    this.toastr.danger(
      'Search results could not be loaded.',
      'Search Error'
    );
  } finally {
    if (
      requestId ===
      this.searchRequestId
    ) {
      this.searchLoading = false;
    }
  }
}




private searchLocalCollection(
  records: any[],
  term: string,
  type:
    | 'job'
    | 'quotation'
): LocalSearchMatch[] {
  return (records || [])
    .map(record => {
      const id = String(
        record?.id ||
        record?.key ||
        ''
      );

      const searchableValues =
        this.getSearchableValues(
          record,
          type
        );

      const score =
        this.calculateSearchScore(
          searchableValues,
          term
        );

      return {
        id,
        data: record,
        score,
      };
    })
    .filter(
      match => match.score > 0
    )
    .sort(
      (a, b) =>
        b.score - a.score
    );
}

private calculateSearchScore(
  values: string[],
  term: string
): number {
  let bestScore = 0;

  for (const value of values) {
    const normalized =
      this.normalizeSearchTerm(value);

    if (!normalized) {
      continue;
    }

    if (normalized === term) {
      bestScore = Math.max(
        bestScore,
        100
      );

      continue;
    }

    if (normalized.startsWith(term)) {
      bestScore = Math.max(
        bestScore,
        75
      );

      continue;
    }

    if (normalized.includes(term)) {
      bestScore = Math.max(
        bestScore,
        50
      );
    }
  }

  return bestScore;
}


private getSearchableValues(
  record: any,
  type:
    | 'job'
    | 'quotation'
): string[] {
  switch (type) {
    case 'job':
      return this.getJobSearchValues(
        record
      );

    case 'quotation':
      return this
        .getQuotationSearchValues(
          record
        );

    default:
      return [];
  }
}



private getJobSearchValues(
  job: any
): string[] {
  const jobData =
    job?.jobData || {};

  const master =
    job?.master ||
    jobData?.master ||
    {};

  const houses =
    Array.isArray(job?.houses)
      ? job.houses
      : Array.isArray(jobData?.houses)
        ? jobData.houses
        : [];

  const charges = [
    ...(Array.isArray(
      job?.charges?.payables
    )
      ? job.charges.payables
      : []),

    ...(Array.isArray(
      job?.charges?.receivables
    )
      ? job.charges.receivables
      : []),
  ];

  return this.flattenSearchValues([
    job?.id,
    job?.refNo,
    job?.referenceNo,
    job?.jobNo,
    job?.jobNumber,
    job?.bookingNo,
    job?.quotationId,
    job?.direction,
    job?.mode,

    master?.refNo,
    master?.mblAwb,
    master?.mbl,
    master?.mblNo,
    master?.awb,
    master?.awbNo,
    master?.bookingNo,
    master?.quotationId,
    master?.direction,
    master?.mode,
    master?.line,
    master?.forwardAgent,
    master?.consignee,
    master?.shipper,
    master?.shipperSupplier,
    master?.pol,
    master?.portOfLoading,
    master?.pod,
    master?.podTerminal,
    master?.portOfDischarge,
    master?.viaPort,
    master?.vesVoyage,
    master?.vessel,
    master?.igmNo,

    houses.flatMap((house: any) => [
      house?.hHawblNo,
      house?.hblNo,
      house?.hblNumber,
      house?.hCustomer,
      house?.customer,
      house?.hConsignee,
      house?.consignee,
      house?.hSupplier,
      house?.hShipper,
      house?.shipper,
      house?.hAgent,
      house?.hClearingAgent,
      house?.hLine,
      house?.hPol,
      house?.hPod,
      house?.containers,
    ]),

    charges.flatMap((charge: any) => [
      charge?.charge_label,
      charge?.customer_label,
      charge?.agent_label,
      charge?.line_label,
      charge?.partyLabel,
      charge?.accountLabel,
      charge?.quotationId,
      charge?.mblNo,
      charge?.hblNo,
      charge?.invoiceNo,
      charge?.remarks,
    ]),
  ]);
}

private flattenSearchValues(
  input: unknown
): string[] {
  const values: string[] = [];
  const visited =
    new WeakSet<object>();

  const walk = (
    value: unknown
  ): void => {
    if (
      value === null ||
      value === undefined
    ) {
      return;
    }

    if (
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      const text =
        String(value).trim();

      if (text) {
        values.push(text);
      }

      return;
    }

    if (value instanceof Date) {
      values.push(
        value.toISOString()
      );

      return;
    }

    if (Array.isArray(value)) {
      value.forEach(walk);
      return;
    }

    if (typeof value === 'object') {
      const objectValue =
        value as any;

      if (
        typeof objectValue?.toDate ===
        'function'
      ) {
        const date =
          objectValue.toDate();

        if (
          date instanceof Date &&
          !isNaN(date.getTime())
        ) {
          values.push(
            date.toISOString()
          );
        }

        return;
      }

      if (visited.has(objectValue)) {
        return;
      }

      visited.add(objectValue);

      Object.values(
        objectValue
      ).forEach(walk);
    }
  };

  walk(input);

  return values;
}




private getQuotationSearchValues(
  quotation: any
): string[] {
  const master =
    quotation?.master &&
    typeof quotation.master === 'object'
      ? quotation.master
      : {};

  const houses =
    Array.isArray(quotation?.houses)
      ? quotation.houses
      : [];

  const steps =
    Array.isArray(quotation?.steps)
      ? quotation.steps
      : [];

  const informationStep =
  steps.find((step: any) =>
    this.normalize(step?.name).includes('information')
  )?.data || {};

const information = {
  ...(quotation?.information || {}),
  ...(quotation?.Information || {}),
  ...(quotation?.informationBlock || {}),
  ...informationStep,
};

  const charges = [
    ...(Array.isArray(quotation?.charges)
      ? quotation.charges
      : []),

    ...(Array.isArray(
      quotation?.charges?.payables
    )
      ? quotation.charges.payables
      : []),

    ...(Array.isArray(
      quotation?.charges?.receivables
    )
      ? quotation.charges.receivables
      : []),
  ];

  return this.flattenSearchValues([
    quotation?.id,
    quotation?.key,

    quotation?.quotationId,
    quotation?.quotationNo,
    quotation?.quoteNo,
    quotation?.quoteNumber,
    quotation?.referenceNo,
    quotation?.refNo,

    quotation?.bookingNo,
    quotation?.jobNo,
    quotation?.jobId,

    quotation?.customer,
    quotation?.customerName,
    quotation?.customerId,
    quotation?.customer_label,

    information?.customer,
information?.customerName,
information?.customer_label,
    quotation?.shipper,
    quotation?.shipperName,
    quotation?.shipperId,

    quotation?.consignee,
    quotation?.consigneeName,
    quotation?.consigneeId,

    quotation?.agent,
    quotation?.agentName,
    quotation?.agentId,

    quotation?.salesPerson,
    quotation?.salesPersonName,
    quotation?.salesExecutive,
    quotation?.createdBy,
    quotation?.createdByName,

    quotation?.status,
    quotation?.mode,
    quotation?.direction,

    quotation?.pol,
    quotation?.pod,
    quotation?.portOfLoading,
    quotation?.portOfDischarge,

    quotation?.mblAwb,
    quotation?.mblNo,
    quotation?.hblNo,

    quotation?.remarks,
    quotation?.description,
    quotation?.commodity,

    master,

    houses.flatMap((house: any) => [
      house?.hHawblNo,
      house?.hblNo,
      house?.hCustomer,
      house?.hConsignee,
      house?.hSupplier,
      house?.hShipper,
      house?.hAgent,
      house?.hClearingAgent,
      house?.hLine,
      house?.hPol,
      house?.hPod,
      house?.containers,
    ]),

    steps,

    charges.flatMap((charge: any) => [
      charge?.charge_label,
      charge?.chargeName,
      charge?.customer_label,
      charge?.agent_label,
      charge?.line_label,
      charge?.partyLabel,
      charge?.accountLabel,
      charge?.description,
      charge?.remarks,
      charge?.currency,
      charge?.rate,
      charge?.amount,
    ]),
  ]);
}












/**
 * Resolves quotation party/user IDs with targeted reads only.
 *
 * Why:
 * - quotation fields often contain Firestore document IDs;
 * - labels are not guaranteed to be saved on older quotations;
 * - loading all entities/users on header initialization would consume many reads.
 *
 * Read policy:
 * - only unique IDs present in current quotation results are fetched;
 * - every resolved or missing ID is cached;
 * - subsequent searches reuse the cache and perform zero reads for those IDs.
 */





private async primeQuotationLookupNames(
  quotations: Record<string, any>[]
): Promise<void> {
  const entityIds = new Set<string>();
  const userIds = new Set<string>();

  for (const quotation of quotations || []) {
    const steps = Array.isArray(quotation?.steps)
      ? quotation.steps
      : [];

    const informationStep = steps.find((step: any) =>
      this.normalize(step?.name).includes('information')
    )?.data || {};

    const information = {
      ...(quotation?.information || {}),
      ...(quotation?.Information || {}),
      ...(quotation?.informationBlock || {}),
      ...informationStep,
    };

    [
      information?.customer,
      quotation?.customer,
      information?.shipperSupplier,
      information?.shipper,
      quotation?.shipperSupplier,
      quotation?.shipper,
      information?.consignee,
      quotation?.consignee,
    ].forEach(value => {
      const id = String(value ?? '').trim();

      if (
        id &&
        this.looksLikeFirestoreDocumentId(id) &&
        !this.entityNameCache.has(id)
      ) {
        entityIds.add(id);
      }
    });

    [
      information?.salesPerson,
      quotation?.salesPerson,
    ].forEach(value => {
      const id = String(value ?? '').trim();

      if (
        id &&
        this.looksLikeFirestoreDocumentId(id) &&
        !this.userNameCache.has(id)
      ) {
        userIds.add(id);
      }
    });
  }

  await Promise.all([
    ...Array.from(entityIds).map(id =>
      this.loadEntityNameIntoCache(id)
    ),
    ...Array.from(userIds).map(id =>
      this.loadUserNameIntoCache(id)
    ),
  ]);
}

private async loadEntityNameIntoCache(
  id: string
): Promise<void> {
  try {
    const snapshot = await getDoc(
      doc(this.firestore, 'entities', id)
    );

    const entity: any = snapshot.exists()
      ? snapshot.data()
      : {};

    this.entityNameCache.set(
      id,
      this.firstNonEmpty(
        entity?.businessName,
        entity?.companyName,
        entity?.company,
        entity?.name,
        entity?.displayName,
        entity?.shortName
      )
    );
  } catch (error) {
    console.warn(`Could not resolve entity ${id}:`, error);
    this.entityNameCache.set(id, '');
  }
}

private async loadUserNameIntoCache(
  id: string
): Promise<void> {
  try {
    const snapshot = await getDoc(
      doc(this.firestore, 'users', id)
    );

    const user: any = snapshot.exists()
      ? snapshot.data()
      : {};

    this.userNameCache.set(
      id,
      this.firstNonEmpty(
        user?.fullName,
        user?.displayName,
        user?.name,
        user?.email
      )
    );
  } catch (error) {
    console.warn(`Could not resolve user ${id}:`, error);
    this.userNameCache.set(id, '');
  }
}

private getCachedEntityName(value: unknown): string {
  const text = String(value ?? '').trim();

  if (!text) {
    return '';
  }

  return this.looksLikeFirestoreDocumentId(text)
    ? this.entityNameCache.get(text) || ''
    : text;
}

private getCachedUserName(value: unknown): string {
  const text = String(value ?? '').trim();

  if (!text) {
    return '';
  }

  return this.looksLikeFirestoreDocumentId(text)
    ? this.userNameCache.get(text) || ''
    : text;
}

private looksLikeFirestoreDocumentId(
  value: unknown
): boolean {
  return /^[A-Za-z0-9]{18,30}$/.test(
    String(value ?? '').trim()
  );
}

private mapQuotationResult(
  id: string,
  quotation: any
): GlobalSearchResult | null {
  if (!quotation || quotation.deleted === true) return null;

  const steps = Array.isArray(quotation.steps) ? quotation.steps : [];
  const informationStep = steps.find((step: any) =>
    this.normalize(step?.name).includes('information')
  )?.data || {};

  const information = {
    ...(quotation.information || {}),
    ...(quotation.Information || {}),
    ...(quotation.informationBlock || {}),
    ...informationStep,
  };

  const quotationId = this.firstNonEmpty(
    quotation.quotationId,
    information.quotationId,
    id
  );

  const direction = this.firstNonEmpty(
    quotation.direction,
    information.direction
  );

  const mode = this.firstNonEmpty(
    quotation.mode,
    information.mode
  );

  const customerId = this.firstNonEmpty(
    information.customer,
    quotation.customer
  );

  const customer = this.firstNonEmpty(
    information.customer_label,
    quotation.customer_label,
    information.customerName,
    quotation.customerName,
    this.getCachedEntityName(customerId)
  );

  const shipperId = this.firstNonEmpty(
    information.shipperSupplier,
    information.shipper,
    quotation.shipperSupplier,
    quotation.shipper
  );

  const shipper = this.firstNonEmpty(
    information.shipperSupplier_label,
    quotation.shipperSupplier_label,
    information.shipper_label,
    quotation.shipper_label,
    information.shipperSupplierName,
    quotation.shipperSupplierName,
    this.getCachedEntityName(shipperId)
  );

  const consigneeId = this.firstNonEmpty(
    information.consignee,
    quotation.consignee
  );

  const consignee = this.firstNonEmpty(
    information.consignee_label,
    quotation.consignee_label,
    information.consigneeName,
    quotation.consigneeName,
    this.getCachedEntityName(consigneeId)
  );

  const salespersonId = this.firstNonEmpty(
    information.salesPerson,
    quotation.salesPerson
  );

  const salesperson = this.firstNonEmpty(
    information.salesPerson_label,
    quotation.salesPerson_label,
    information.salesperson_label,
    quotation.salesperson_label,
    information.salesPersonName,
    quotation.salesPersonName,
    this.getCachedUserName(salespersonId)
  );

  const pol = this.firstNonEmpty(
    quotation.pol,
    information.pol,
    information.loadingAirport
  );

  const pod = this.firstNonEmpty(
    quotation.podTerminal,
    quotation.pod,
    information.podTerminal,
    information.pod,
    information.destinationAirport
  );

  const mbl = this.firstNonEmpty(
    quotation.mblAwb,
    information.mblAwb
  );

  const bookingNumber = this.firstNonEmpty(
    quotation.bookingNumber,
    information.bookingNumber
  );

  const status = this.firstNonEmpty(
    quotation.status,
    quotation.approved === true ? 'Approved' : '',
    'Active'
  );

  const buyingCharges = this.extractQuotationCharges(
    quotation,
    ['buying', 'Buying', 'buyingCharges', 'charges.buying', 'charges.payables']
  );

  const sellingCharges = this.extractQuotationCharges(
    quotation,
    ['selling', 'Selling', 'sellingCharges', 'charges.selling', 'charges.receivables']
  );

  const buyingSummary = this.calculateQuotationChargeSummary(buyingCharges);
  const sellingSummary = this.calculateQuotationChargeSummary(sellingCharges);
  const profitSummary = this.calculateCurrencyWiseProfit(
    sellingSummary.originalTotals,
    buyingSummary.originalTotals
  );

  return {
    id: `quotation-${id}`,
    sourceId: id,
    type: 'quotation',
    icon: 'file-text-outline',
    initials: this.makeInitials(quotationId),
    title: quotationId,
    subtitle: [direction, mode, 'Quotation'].filter(Boolean).join(' '),
    status,
    matchedField: this.detectMatchedField([
      { label: 'Quotation Number', values: [quotationId] },
      { label: 'MBL / AWB', values: [mbl] },
      { label: 'Booking Number', values: [bookingNumber] },
      { label: 'Customer', values: [customer] },
    ]),
    meta: [
      customer ? `Customer: ${customer}` : '',
      pol ? `POL: ${pol}` : '',
      pod ? `POD: ${pod}` : '',
      mbl ? `MBL/AWB: ${mbl}` : '',
    ].filter(Boolean),
    metrics: [
      {
        label: 'Buying',
        value: this.formatChargeCurrencies(buyingSummary.originalTotals) || '-',
        tone: 'danger',
      },
      {
        label: 'Selling',
        value: this.formatChargeCurrencies(sellingSummary.originalTotals) || '-',
        tone: 'success',
      },
      {
        label: 'Profit',
        value: this.formatChargeCurrencies(profitSummary) || '-',
        tone: this.getProfitTone(profitSummary),
      },
    ],
    details: [
      this.createDetail('Direction', direction, 'swap-outline'),
      this.createDetail('Mode', mode, 'navigation-outline'),
      this.createDetail('Customer', customer, 'person-outline'),
      this.createDetail('Shipper', shipper, 'person-outline'),
      this.createDetail('Consignee', consignee, 'people-outline'),
      this.createDetail('Salesperson', salesperson, 'person-done-outline'),
      this.createDetail('MBL / AWB', mbl, 'file-text-outline'),
      this.createDetail('Booking Number', bookingNumber, 'bookmark-outline'),
      this.createDetail('POL', pol, 'pin-outline'),
      this.createDetail('POD', pod, 'navigation-2-outline'),
      this.createDetail('Buying Charges', this.formatChargeCurrencies(buyingSummary.originalTotals), 'trending-down-outline'),
      this.createDetail('Selling Charges', this.formatChargeCurrencies(sellingSummary.originalTotals), 'trending-up-outline'),
      this.createDetail('Profit', this.formatChargeCurrencies(profitSummary), 'pie-chart-outline'),
      this.createDetail('Approved Buying Charges', buyingSummary.approvedCount ? String(buyingSummary.approvedCount) : '', 'checkmark-circle-2-outline'),
      this.createDetail('Approved Selling Charges', sellingSummary.approvedCount ? String(sellingSummary.approvedCount) : '', 'checkmark-circle-2-outline'),
    ].filter((detail): detail is SearchDetail => detail !== null),
    activities: [],
    primaryActionLabel: 'Open Quotation',
    route: '/pages/quotation',
  };
}

private getNestedValue(source: any, path: string): any {
  return path.split('.').reduce((value, key) => value?.[key], source);
}

private extractQuotationCharges(quotation: any, paths: string[]): any[] {
  for (const path of paths) {
    const value = this.getNestedValue(quotation, path);
    if (Array.isArray(value)) return value;
    if (value && typeof value === 'object') {
      const arrays = Object.values(value).filter(Array.isArray).flat();
      if (arrays.length) return arrays as any[];
    }
  }

  const steps = Array.isArray(quotation?.steps) ? quotation.steps : [];
  const wantsBuying = paths.some(path => path.toLowerCase().includes('buying'));
  const wantsSelling = paths.some(path => path.toLowerCase().includes('selling'));

  for (const step of steps) {
    const stepName = this.normalize(step?.name);
    if ((wantsBuying && stepName.includes('buying')) ||
        (wantsSelling && stepName.includes('selling'))) {
      const data = step?.data || step;
      if (Array.isArray(data)) return data;
      const arrays = Object.values(data || {}).filter(Array.isArray).flat();
      if (arrays.length) return arrays as any[];
    }
  }

  return [];
}

private calculateQuotationChargeSummary(charges: any[]): {
  originalTotals: Record<string, number>;
  approvedCount: number;
} {
  const originalTotals: Record<string, number> = {};
  let approvedCount = 0;

  (charges || [])
    .filter((charge: any) =>
      charge?.approvalStatus === true ||
      charge?.approved === true ||
      charge?.isApproved === true ||
      this.normalize(charge?.approvalStatus) === 'approved'
    )
    .forEach((charge: any) => {
      const rate = Number(charge?.rate ?? charge?.amount ?? charge?.price ?? 0);
      const units = Number(charge?.units ?? charge?.quantity ?? charge?.qty ?? 1);
      const currency = String(charge?.currency || 'PKR').trim().toUpperCase();
      const total = rate * units;
      originalTotals[currency] = (originalTotals[currency] || 0) + total;
      approvedCount++;
    });

  return { originalTotals, approvedCount };
}








/**
 * Normalizes Firestore Timestamp, JavaScript Date, ISO strings and date-only
 * strings into one readable format. Time is shown only when the source value
 * actually contains a meaningful time component.
 */
private formatSearchDate(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  let date: Date | null = null;
  let includeTime = false;

  if (value instanceof Date) {
    date = value;
    includeTime = true;
  } else if (
    typeof value === 'object' &&
    typeof (value as any)?.toDate === 'function'
  ) {
    date = (value as any).toDate();
    includeTime = true;
  } else if (
    typeof value === 'object' &&
    Number.isFinite(Number((value as any)?.seconds))
  ) {
    date = new Date(Number((value as any).seconds) * 1000);
    includeTime = true;
  } else {
    const text = String(value).trim();

    if (!text) {
      return '';
    }

    // Preserve an unambiguous YYYY-MM-DD value without timezone shifting.
    const dateOnlyMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return `${day}/${month}/${year}`;
    }

    const parsed = new Date(text);

    if (!Number.isNaN(parsed.getTime())) {
      date = parsed;
      includeTime = /[T\s]\d{1,2}:\d{2}/.test(text);
    } else {
      return text;
    }
  }

  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }

  const dateText = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  if (!includeTime) {
    return dateText;
  }

  const timeText = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${dateText}, ${timeText}`;
}



private detectMatchedField(
  fields: Array<{
    label: string;
    values: unknown[];
  }>
): string {
  const term =
    this.normalizeSearchTerm(
      this.searchQuery
    );

  for (const field of fields) {
    const matched =
      field.values.some(value => {
        return this
          .normalizeSearchTerm(value)
          .includes(term);
      });

    if (matched) {
      return field.label;
    }
  }

  return 'Record Data';
}



private mapJobResult(
  id: string,
  job: any
): GlobalSearchResult | null {
  if (!job || job.deleted === true) {
    return null;
  }

  const jobData =
    job.jobData &&
    typeof job.jobData === 'object'
      ? job.jobData
      : {};

  const master =
    job.master &&
    typeof job.master === 'object'
      ? job.master
      : jobData.master &&
          typeof jobData.master === 'object'
        ? jobData.master
        : {};

  const houses = Array.isArray(job.houses)
    ? job.houses
    : Array.isArray(jobData.houses)
      ? jobData.houses
      : [];

  const jobNumber = this.firstNonEmpty(
    job.refNo,
    job.referenceNo,
    job.jobNumber,
    job.jobNo,
    job.manualRef,
    jobData.refNo,
    jobData.jobNumber,
    id
  );

  const direction = this.firstNonEmpty(
    job.direction,
    job.shipmentDirection,
    jobData.direction,
    master.direction
  );

  const mode = this.firstNonEmpty(
    job.mode,
    job.shipmentMode,
    jobData.mode,
    master.mode
  );

  const status = this.firstNonEmpty(
    job.status,
    job.jobStatus,
    jobData.status,
    'Active'
  );

  const customerNames = this.uniqueStrings(
    houses.flatMap((house: any) => [
      house?.customer,
      house?.customerName,
      house?.hCustomer,
      house?.customerBusinessName,
    ])
  );

  const customer = this.firstNonEmpty(
    customerNames[0],
    job.customer,
    job.customerName,
    jobData.customer,
    jobData.customerName,
    master.customer
  );

  const hblNumbers = this.uniqueStrings(
    houses.flatMap((house: any) => [
      house?.hblNo,
      house?.hblNumber,
      house?.hbl,
      house?.houseBl,
      house?.houseBL,
      house?.hblAwb,
    ])
  );

  const mbl = this.firstNonEmpty(
    master.mblAwb,
    master.mbl,
    master.mblNo,
    master.mblNumber,
    master.awb,
    master.awbNo,
    master.mawb,
    job.mblAwb,
    job.mbl,
    job.mblNo,
    job.awb,
    job.awbNo,
    jobData.mblAwb,
    jobData.mbl,
    jobData.mblNo,
    jobData.awb,
    jobData.awbNo
  );

  const pol = this.firstNonEmpty(
    master.pol,
    master.portOfLoading,
    job.pol,
    job.portOfLoading,
    jobData.pol,
    jobData.portOfLoading
  );

  const pod = this.firstNonEmpty(
    master.pod,
    master.podTerminal,
    master.portOfDischarge,
    job.pod,
    job.podTerminal,
    job.portOfDischarge,
    jobData.pod,
    jobData.podTerminal,
    jobData.portOfDischarge
  );

  const vesselVoyage = this.firstNonEmpty(
    master.vesselVoyage,
    master.vesVoyage,
    master.vessel,
    job.vesselVoyage,
    job.vesVoyage,
    jobData.vesselVoyage
  );

  const bookingNumber = this.firstNonEmpty(
    job.bookingNo,
    job.bookingNumber,
    jobData.bookingNo,
    jobData.bookingNumber,
    master.bookingNo
  );

  const quotationNumber = this.firstNonEmpty(
    job.quotationId,
    job.quotationNo,
    job.quotationNumber,
    jobData.quotationId,
    jobData.quotationNo
  );

  const salesperson = this.firstNonEmpty(
    job.salesPerson,
    job.salesperson,
    job.salesPersonName,
    jobData.salesPerson,
    jobData.salesperson,
    master.salesPerson
  );

  const containerNumbers = this.extractContainerNumbers(
    master,
    houses
  );

  const firstHouse =
  houses.length > 0
    ? houses[0]
    : {};

const shipper = this.firstNonEmpty(
  firstHouse?.hSupplier,
  firstHouse?.supplier,
  firstHouse?.shipper,
  firstHouse?.hShipper,
  master.shipperSupplier,
  master.shipper,
  job.shipperSupplier,
  job.shipper,
  jobData.shipperSupplier,
  jobData.shipper
);

const consignee = this.firstNonEmpty(
  firstHouse?.hConsignee,
  firstHouse?.consignee,
  firstHouse?.consigneeName,
  master.consignee,
  job.consignee,
  job.consigneeName,
  jobData.consignee,
  jobData.consigneeName
);

const shippingLine = this.firstNonEmpty(
  master.line,
  master.shippingLine,
  master.lineName,
  master.carrier,
  job.line,
  job.shippingLine,
  job.lineName,
  jobData.line,
  jobData.shippingLine
);

const fullVesselVoyage = this.firstNonEmpty(
  master.vesVoyage,
  master.vesselVoyage,
  firstHouse?.hVesselVoyage,
  job.vesVoyage,
  job.vesselVoyage,
  jobData.vesVoyage,
  jobData.vesselVoyage,
  [
    master.vesselName || master.vessel,
    master.voyageNo || master.voyage,
  ]
    .filter(Boolean)
    .join(' / ')
);

const etd = this.firstNonEmpty(
  master.etd,
  master.departureDate,
  master.sailingDate,
  firstHouse?.hPolDate,
  job.etd,
  job.departureDate,
  jobData.etd
);

const eta = this.firstNonEmpty(
  master.eta,
  master.arrivalDate,
  firstHouse?.hArrivalDate,
  firstHouse?.hPodDate,
  job.eta,
  job.arrivalDate,
  jobData.eta,
  jobData.arrivalDate
);

const grossWeight = this.firstValidNumber(
  master.grossWeight,
  master.totalGrossWeight,
  firstHouse?.hGrossWeight,
  job.grossWeight,
  jobData.grossWeight
);

const volume = this.firstValidNumber(
  master.volume,
  master.billingVolume,
  master.totalCbm,
  firstHouse?.hVolume,
  job.volume,
  jobData.volume
);

const resolvedBookingNumber = this.firstNonEmpty(
  bookingNumber,
  firstHouse?.hBookingNo,
  firstHouse?.bookingNo
);

const resolvedQuotationNumber = this.firstNonEmpty(
  quotationNumber,
  master.quotationId,
  firstHouse?.quotationId,
  firstHouse?.quotationNo
);

const resolvedSalesperson = this.firstNonEmpty(
  salesperson,
  firstHouse?.hSalesPerson,
  firstHouse?.salesPerson
);

    const receivableCharges = Array.isArray(
  job?.charges?.receivables
)
  ? job.charges.receivables
  : [];

const payableCharges = Array.isArray(
  job?.charges?.payables
)
  ? job.charges.payables
  : [];

const receivableSummary =
  this.calculateJobChargeSummary(
    receivableCharges
  );

const payableSummary =
  this.calculateJobChargeSummary(
    payableCharges
  );

const profitSummary =
  this.calculateCurrencyWiseProfit(
    receivableSummary.originalTotals,
    payableSummary.originalTotals
  );

  const ledgerSummary =
  this.getJobLedgerSummary(
    id,
    job,
    jobNumber,
    master,
    houses
  );

const totalReceivable =
  this.formatLedgerCurrencyFieldOrZero(
    ledgerSummary,
    'totalReceivable'
  );

const receivableBalance =
  this.formatLedgerCurrencyFieldOrZero(
    ledgerSummary,
    'receivableBalance'
  );

const totalPayable =
  this.formatLedgerCurrencyFieldOrZero(
    ledgerSummary,
    'totalPayable'
  );

const payableBalance =
  this.formatLedgerCurrencyFieldOrZero(
    ledgerSummary,
    'payableBalance'
  );

const netBalance =
  this.formatLedgerCurrencyFieldOrZero(
    ledgerSummary,
    'netBalance'
  );

  return {
  id: `job-${id}`,
  sourceId: id,
  type: 'job',

  icon: 'briefcase-outline',
  initials: this.makeInitials(jobNumber),

  title: jobNumber,

  subtitle: [
    direction,
    mode,
    'Job',
  ]
    .filter(Boolean)
    .join(' '),

  status,

  matchedField: this.detectJobMatchedField(job),

  meta: [
    customer
      ? `Customer: ${customer}`
      : '',

    hblNumbers.length
      ? `HBL: ${hblNumbers
          .slice(0, 2)
          .join(', ')}${
            hblNumbers.length > 2
              ? ` +${hblNumbers.length - 2}`
              : ''
          }`
      : '',

    mbl
      ? `MBL/AWB: ${mbl}`
      : '',

    pol
      ? `POL: ${pol}`
      : '',

    pod
      ? `POD: ${pod}`
      : '',
  ].filter(Boolean),

metrics: [
  {
    label: 'Invoices',
    value:
      String(
        ledgerSummary.totalInvoiceCount
      ),
    tone: 'primary',
  },
  {
    label: 'Receivable Balance',
    value: receivableBalance,
    tone: 'success',
  },
  {
    label: 'Payable Balance',
    value: payableBalance,
    tone: 'danger',
  },
],

 details: [
  this.createDetail(
    'Customer',
    customer,
    'person-outline'
  ),

  this.createDetail(
    'Shipper',
    shipper,
    'person-outline'
  ),

  this.createDetail(
    'Consignee',
    consignee,
    'people-outline'
  ),

  this.createDetail(
    'Shipping Line',
    shippingLine,
    'navigation-outline'
  ),

  this.createDetail(
    'MBL / AWB',
    mbl,
    'file-text-outline'
  ),

  this.createDetail(
    'HBL / HAWB',
    hblNumbers.join(', '),
    'file-text-outline'
  ),

  this.createDetail(
    'POL',
    pol,
    'pin-outline'
  ),

  this.createDetail(
    'POD',
    pod,
    'navigation-2-outline'
  ),

  this.createDetail(
    'Vessel / Voyage',
    fullVesselVoyage,
    'navigation-outline'
  ),

  this.createDetail(
    'ETD',
    etd,
    'calendar-outline'
  ),

  this.createDetail(
    'ETA / Arrival',
    eta,
    'calendar-outline'
  ),

  this.createDetail(
    'Containers',
    containerNumbers.join(', '),
    'cube-outline'
  ),

  this.createDetail(
    'Container Count',
    containerNumbers.length
      ? String(containerNumbers.length)
      : '',
    'cube-outline'
  ),

  this.createDetail(
    'Gross Weight',
    this.formatSearchNumber(
      grossWeight,
      'KG'
    ),
    'archive-outline'
  ),

  this.createDetail(
    'Volume',
    this.formatSearchNumber(
      volume,
      'CBM'
    ),
    'expand-outline'
  ),

  this.createDetail(
    'Booking Number',
    resolvedBookingNumber,
    'bookmark-outline'
  ),

  this.createDetail(
    'Quotation Number',
    resolvedQuotationNumber,
    'file-text-outline'
  ),

  this.createDetail(
    'Salesperson',
    resolvedSalesperson,
    'person-done-outline'
  ),

  this.createDetail(
    'Receivable Charges',
    this.formatChargeCurrencies(
      receivableSummary.originalTotals
    ),
    'trending-up-outline'
  ),



  this.createDetail(
    'Payable Charges',
    this.formatChargeCurrencies(
      payableSummary.originalTotals
    ),
    'trending-down-outline'
  ),



 

  this.createDetail(
    'Approved Receivable Charges',
    receivableSummary.approvedCount
      ? String(
          receivableSummary.approvedCount
        )
      : '',
    'checkmark-circle-2-outline'
  ),

  this.createDetail(
    'Approved Payable Charges',
    payableSummary.approvedCount
      ? String(
          payableSummary.approvedCount
        )
      : '',
    'checkmark-circle-2-outline'
  ),

  this.createDetail(
  'Total Invoices',
  String(
    ledgerSummary.totalInvoiceCount
  ),
  'file-text-outline'
),

this.createDetail(
  'Receivable Invoices',
  String(
    ledgerSummary
      .receivableInvoiceCount
  ),
  'trending-up-outline'
),

this.createDetail(
  'Payable Invoices',
  String(
    ledgerSummary
      .payableInvoiceCount
  ),
  'trending-down-outline'
),

this.createDetail(
  'Invoice Numbers',
  ledgerSummary.invoiceNumbers
    .join(', '),
  'list-outline'
),

this.createDetail(
  'Total Receivable',
  totalReceivable,
  'trending-up-outline'
),

this.createDetail(
  'Receivable Balance',
  receivableBalance,
  'credit-card-outline'
),

this.createDetail(
  'Total Payable',
  totalPayable,
  'trending-down-outline'
),

this.createDetail(
  'Payable Balance',
  payableBalance,
  'credit-card-outline'
),

this.createDetail(
  'Net Balance',
  netBalance,
  'pie-chart-outline'
),
].filter(
  (detail): detail is SearchDetail =>
    detail !== null
),

  activities: [],

  primaryActionLabel: 'Open Job',

  route: '',

  __rawJob: job,
} as GlobalSearchResult & {
  __rawJob: Record<string, any>;
};
}


// New Helpers For Receivable And PAyables OF the JOb and existing Data // 


private firstValidNumber(
  ...values: unknown[]
): number | null {
  for (const value of values) {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      continue;
    }

    const numberValue = Number(value);

    if (Number.isFinite(numberValue)) {
      return numberValue;
    }
  }

  return null;
}

private calculateJobChargeSummary(
  charges: any[]
): {
  originalTotals: Record<string, number>;
  baseTotal: number;
  approvedCount: number;
} {
  const originalTotals: Record<string, number> = {};

  let baseTotal = 0;
  let approvedCount = 0;

  (charges || [])
    .filter((charge: any) => {
      return charge?.approvalStatus === true;
    })
    .forEach((charge: any) => {
      const rate = Number(
        charge?.rate ||
        charge?.amount ||
        0
      );

      const units = Number(
        charge?.units ||
        charge?.quantity ||
        1
      );

      const exchangeRate = Number(
        charge?.exchangeRate ||
        1
      );

      const currency = String(
        charge?.currency || 'PKR'
      )
        .trim()
        .toUpperCase();

      const originalAmount =
        rate * units;

      const convertedAmount =
        currency === 'PKR'
          ? originalAmount
          : originalAmount * exchangeRate;

      originalTotals[currency] =
        (originalTotals[currency] || 0) +
        originalAmount;

      baseTotal += convertedAmount;
      approvedCount++;
    });

  return {
    originalTotals,
    baseTotal,
    approvedCount,
  };
}

private formatChargeCurrencies(
  totals: Record<string, number>
): string {
  const entries = Object.entries(
    totals || {}
  );

  if (!entries.length) {
    return '';
  }

  return entries
    .map(([currency, amount]) => {
      return `${currency} ${amount.toLocaleString(
        undefined,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`;
    })
    .join(' / ');
}




private calculateCurrencyWiseProfit(
  receivables: Record<string, number>,
  payables: Record<string, number>
): Record<string, number> {
  const currencies = new Set<string>([
    ...Object.keys(receivables || {}),
    ...Object.keys(payables || {}),
  ]);

  const result: Record<string, number> = {};

  currencies.forEach(currency => {
    const receivableAmount =
      Number(receivables?.[currency] || 0);

    const payableAmount =
      Number(payables?.[currency] || 0);

    result[currency] =
      receivableAmount - payableAmount;
  });

  return result;
}

private getProfitTone(
  profitTotals: Record<string, number>
): SearchMetric['tone'] {
  const values = Object.values(
    profitTotals || {}
  );

  if (!values.length) {
    return undefined;
  }

  return values.some(value => value < 0)
    ? 'danger'
    : 'success';
}

private formatSearchNumber(
  value: number | null,
  suffix = ''
): string {
  if (
    value === null ||
    !Number.isFinite(value)
  ) {
    return '';
  }

  const formatted =
    value.toLocaleString(
      undefined,
      {
        maximumFractionDigits: 3,
      }
    );

  return suffix
    ? `${formatted} ${suffix}`
    : formatted;
}


// New Helpers For Receivable And PAyables OF the JOb and existing Data // 




private looksLikeFirestoreId(
  value: unknown
): boolean {
  const text = String(value ?? '').trim();

  return /^[A-Za-z0-9]{18,30}$/.test(text);
}

private firstDisplayName(
  ...values: unknown[]
): string {
  for (const value of values) {
    const text = String(value ?? '').trim();

    if (
      text &&
      !this.looksLikeFirestoreId(text)
    ) {
      return text;
    }
  }

  return '';
}

private firstNonEmpty(
  ...values: unknown[]
): string {
  for (const value of values) {
    const text = String(value ?? '').trim();

    if (text) {
      return text;
    }
  }

  return '';
}

private uniqueStrings(
  values: unknown[]
): string[] {
  const uniqueValues = new Set<string>();

  values.forEach(value => {
    const text = String(value ?? '').trim();

    if (text) {
      uniqueValues.add(text);
    }
  });

  return Array.from(uniqueValues);
}

private extractContainerNumbers(
  master: any,
  houses: any[]
): string[] {
  const numbers = new Set<string>();

  const addContainers = (containers: unknown): void => {
    if (!Array.isArray(containers)) {
      return;
    }

    containers.forEach((container: any) => {
      const number = this.firstNonEmpty(
        container?.number,
        container?.containerNumber,
        container?.containerNo,
        container?.contNo
      );

      if (number) {
        numbers.add(number);
      }
    });
  };

  addContainers(master?.containers);
  addContainers(master?.scContainers);

  houses.forEach((house: any) => {
    addContainers(house?.containers);
    addContainers(house?.hContainers);
    addContainers(house?.scContainers);
  });

  return Array.from(numbers);
}





private detectJobMatchedField(
  job: any
): string {
  const term = this.normalizeSearchTerm(
    this.searchQuery
  );

  const jobData = job?.jobData || {};

  const master =
    job?.master ||
    jobData?.master ||
    {};

  const houses = Array.isArray(job?.houses)
    ? job.houses
    : Array.isArray(jobData?.houses)
      ? jobData.houses
      : [];

  const containerNumbers =
    this.extractContainerNumbers(
      master,
      houses
    );



  const fields: Array<{
    label: string;
    values: unknown[];
  }> = [
    {
      label: 'Job Number',
      values: [
        job.refNo,
        job.referenceNo,
        job.jobNumber,
        job.jobNo,
        job.manualRef,
        jobData.refNo,
        jobData.jobNumber,
      ],
    },
    {
      label: 'MBL / AWB',
      values: [
        master.mblAwb,
        master.mbl,
        master.mblNo,
        master.mblNumber,
        master.awb,
        master.awbNo,
        master.mawb,
        job.mblAwb,
        job.mbl,
        job.mblNo,
        job.awb,
        jobData.mblAwb,
        jobData.mbl,
      ],
    },
    {
      label: 'HBL',
      values: houses.flatMap((house: any) => [
        house?.hblNo,
        house?.hblNumber,
        house?.hbl,
        house?.houseBl,
        house?.houseBL,
        house?.hblAwb,
      ]),
    },
    {
      label: 'Customer',
      values: [
        job.customer,
        job.customerName,
        jobData.customer,
        ...houses.flatMap((house: any) => [
          house?.customer,
          house?.customerName,
          house?.hCustomer,
        ]),
      ],
    },
    {
      label: 'Container Number',
      values: containerNumbers,
    },
    {
      label: 'Booking Number',
      values: [
        job.bookingNo,
        job.bookingNumber,
        jobData.bookingNo,
        master.bookingNo,
      ],
    },
    {
      label: 'Quotation Number',
      values: [
        job.quotationId,
        job.quotationNo,
        job.quotationNumber,
        jobData.quotationId,
      ],
    },
    {
      label: 'POL',
      values: [
        master.pol,
        master.portOfLoading,
        job.pol,
        jobData.pol,
      ],
    },
    {
      label: 'POD',
      values: [
        master.pod,
        master.podTerminal,
        master.portOfDischarge,
        job.pod,
        jobData.pod,
      ],
    },
  ];

  for (const field of fields) {
    const matched = field.values.some(value =>
      this
        .normalizeSearchTerm(value)
        .includes(term)
    );

    if (matched) {
      return field.label;
    }
  }

  return 'Job Data';
}

private normalize(value: unknown): string {
  return String(value ?? '')
    .toLowerCase()
    .trim();
}

private createDetail(
  label: string,
  value: unknown,
  icon: string
): SearchDetail | null {
  const text = String(value ?? '').trim();

  if (!text) {
    return null;
  }

  return {
    label,
    value: text,
    icon,
  };
}

private makeInitials(value: string): string {
  const words = String(value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!words.length) {
    return '--';
  }

  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }

  return `${words[0][0]}${words[1][0]}`.toUpperCase();
}



private statusMetricTone(
  status: string
): SearchMetric['tone'] {
  const normalized = this.normalize(status);

  if (
    normalized.includes('inactive') ||
    normalized.includes('cancel') ||
    normalized.includes('block')
  ) {
    return 'danger';
  }

  if (
    normalized.includes('progress') ||
    normalized.includes('pending')
  ) {
    return 'warning';
  }

  if (
    normalized.includes('active') ||
    normalized.includes('complete')
  ) {
    return 'success';
  }

  return undefined;
}



selectSearchCategory(
  category: 'all' | SearchResultType
): void {
  this.activeSearchCategory = category;

  const firstResult = this.filteredSearchResults[0] || null;
  this.selectedSearchResult = firstResult;
}

selectSearchResult(
  result: GlobalSearchResult,
  event?: MouseEvent
): void {
  event?.preventDefault();
  event?.stopPropagation();

  /*
   * New object reference force karte hain,
   * taake Angular preview bindings definitely refresh hon.
   */
  this.selectedSearchResult = {
    ...result,
    meta: [...(result.meta || [])],
    metrics: [...(result.metrics || [])],
    details: [...(result.details || [])],
    activities: [...(result.activities || [])],
  };
}

isSearchResultSelected(
  result: GlobalSearchResult
): boolean {
  const selected =
    this.selectedSearchResult;

  if (!selected) {
    return false;
  }

  return (
  selected.type === result.type &&
  selected.sourceId ===
    result.sourceId
);
}

openSelectedSearchResult(): void {
  const selected = this.selectedSearchResult;

  if (!selected) {
    return;
  }

  this.openSearchResult(selected);
}

openSearchResult(
  result: GlobalSearchResult | null
): void {
  if (!result) {
    return;
  }

  // Only job requires custom routing.
  if (result.type === 'job') {
    this.openJobFromSearch(result);
    return;
  }

  // Existing quotation navigation remains unchanged.
  if (!result.route) {
    this.toastr.warning(
      'This record does not have a valid route.',
      'Cannot Open Record'
    );
    return;
  }

  this.closeGlobalSearch();

  this.router.navigate(
    [result.route],
    {
      queryParams: {
        id: result.sourceId,
        type: result.type,
      },
    }
  );
}


private openJobFromSearch(
  result: GlobalSearchResult
): void {
  const jobKey = result.sourceId;

  const jobResult = this.globalSearchResults.find(
    item =>
      item.type === 'job' &&
      item.sourceId === jobKey
  );

  if (!jobResult) {
    return;
  }

  const rawJob =
    (jobResult as any).__rawJob || {};

  const direction = this.normalize(
    rawJob.direction ||
    rawJob.shipmentDirection ||
    rawJob.jobData?.direction ||
    ''
  );

  const source = this.normalize(
    rawJob.source ||
    rawJob.jobData?.source ||
    ''
  );

  const quotationKey = String(
    rawJob.quotationKey ||
    rawJob.quotationId ||
    rawJob.jobData?.quotationKey ||
    ''
  ).trim();

  this.closeGlobalSearch();

  if (source === 'booking') {
    this.forceNavigate([
      '/pages/house-details',
      jobKey,
      quotationKey,
    ]);

    return;
  }

  if (direction === 'import') {
    this.forceNavigate(
      ['/pages/operations/import-mbl'],
      {
        queryParams: {
          formKey: 'importmbl',
          jobKey,
        },
      }
    );

    return;
  }

  if (direction === 'export') {
    this.forceNavigate(
      ['/pages/operations/export-mbl'],
      {
        queryParams: {
          formKey: 'exportmbl',
          jobKey,
        },
      }
    );

    return;
  }

  this.router.navigate(
    ['/pages/operations/view-bls'],
    {
      queryParams: {
        jobKey,
      },
    }
  );
}

private forceNavigate(
  commands: any[],
  extras: any = {}
): void {
  this.router
    .navigateByUrl(
      '/pages',
      {
        skipLocationChange: true,
      }
    )
    .then(() => {
      this.router.navigate(
        commands,
        extras
      );
    });
}



runQuickAction(action: QuickSearchAction): void {
  this.closeGlobalSearch();
  this.router.navigateByUrl(action.route);
}

private loadRecentSearches(): void {
  try {
    const stored = localStorage.getItem(
      this.recentSearchStorageKey
    );

    if (!stored) {
      this.recentSearches = [];
      return;
    }

    const parsed = JSON.parse(stored);

    this.recentSearches = Array.isArray(parsed)
      ? parsed
          .map(item => String(item || '').trim())
          .filter(Boolean)
          .slice(0, this.maximumRecentSearches)
      : [];
  } catch (error) {
    console.warn(
      'Recent searches could not be loaded:',
      error
    );

    this.recentSearches = [];
  }
}

private saveRecentSearch(
  value: string
): void {
  const searchValue = String(value || '').trim();

  if (
    searchValue.length <
    this.minimumSearchLength
  ) {
    return;
  }

  const normalizedValue =
    this.normalizeSearchTerm(searchValue);

  const withoutDuplicate =
    this.recentSearches.filter(item => {
      return (
        this.normalizeSearchTerm(item) !==
        normalizedValue
      );
    });

  this.recentSearches = [
    searchValue,
    ...withoutDuplicate,
  ].slice(0, this.maximumRecentSearches);

  try {
    localStorage.setItem(
      this.recentSearchStorageKey,
      JSON.stringify(this.recentSearches)
    );
  } catch (error) {
    console.warn(
      'Recent searches could not be saved:',
      error
    );
  }
}

removeRecentSearch(
  value: string,
  event?: MouseEvent
): void {
  event?.stopPropagation();

  const normalizedValue =
    this.normalizeSearchTerm(value);

  this.recentSearches =
    this.recentSearches.filter(item => {
      return (
        this.normalizeSearchTerm(item) !==
        normalizedValue
      );
    });

  try {
    localStorage.setItem(
      this.recentSearchStorageKey,
      JSON.stringify(this.recentSearches)
    );
  } catch (error) {
    console.warn(
      'Recent search could not be removed:',
      error
    );
  }
}

clearRecentSearches(): void {
  this.recentSearches = [];

  try {
    localStorage.removeItem(
      this.recentSearchStorageKey
    );
  } catch (error) {
    console.warn(
      'Recent searches could not be cleared:',
      error
    );
  }
}

useRecentSearch(value: string): void {
  this.searchQuery = value;

  const input =
    this.globalSearchInput?.nativeElement;

  if (input) {
    input.value = value;
    input.focus();
  }

  if (this.searchDebounceTimer) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = undefined;
  }

  const rawTerm = value.trim();

  const normalizedTerm =
    this.normalizeSearchTerm(rawTerm);

  if (
    normalizedTerm.length <
    this.minimumSearchLength
  ) {
    this.searchRequestId++;

    this.globalSearchResults = [];
    this.selectedSearchResult = null;
    this.searchLoading = false;

    return;
  }

  this.searchLoading = true;

  this.searchDebounceTimer = setTimeout(() => {
    void this.searchFirebase(
      rawTerm,
      normalizedTerm
    );
  }, 350);
}

onSearchBackdropMouseDown(event: MouseEvent): void {
  if (event.target === event.currentTarget) {
    this.closeGlobalSearch();
  }
}

onSearchInputKeydown(event: KeyboardEvent): void {
  if (event.key === 'Escape') {
    event.preventDefault();
    this.closeGlobalSearch();
    return;
  }

  if (
    event.key === 'ArrowDown' ||
    event.key === 'ArrowUp'
  ) {
    event.preventDefault();

    this.moveSearchSelection(
      event.key === 'ArrowDown' ? 1 : -1
    );

    return;
  }

if (event.key === 'Enter') {
  event.preventDefault();

  const rawTerm =
    this.searchQuery.trim();

  const normalizedTerm =
    this.normalizeSearchTerm(rawTerm);

  if (
    normalizedTerm.length <
    this.minimumSearchLength
  ) {
    return;
  }

  const resultsBelongToCurrentTerm =
    this.lastExecutedSearchTerm ===
    normalizedTerm;

  if (
    resultsBelongToCurrentTerm &&
    this.selectedSearchResult
  ) {
    this.openSelectedSearchResult();
    return;
  }

  this.globalSearchResults = [];
  this.selectedSearchResult = null;
  this.searchLoading = true;

  void this.searchFirebase(
    rawTerm,
    normalizedTerm
  );
}
}

private moveSearchSelection(
  direction: 1 | -1
): void {
  const results =
    this.filteredSearchResults;

  if (!results.length) {
    this.selectedSearchResult = null;
    return;
  }

  const currentIndex =
    this.selectedSearchResult
      ? results.findIndex(result =>
          this.isSearchResultSelected(result)
        )
      : -1;

  let nextIndex =
    currentIndex + direction;

  if (nextIndex < 0) {
    nextIndex =
      results.length - 1;
  }

  if (nextIndex >= results.length) {
    nextIndex = 0;
  }

  const nextResult =
    results[nextIndex];

  this.selectedSearchResult = {
    ...nextResult,
    meta: [...(nextResult.meta || [])],
    metrics: [...(nextResult.metrics || [])],
    details: [...(nextResult.details || [])],
    activities: [...(nextResult.activities || [])],
  };

  setTimeout(() => {
    const selectedElement =
      document.querySelector<HTMLElement>(
        '.global-result-card.selected'
      );

    selectedElement?.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
    });
  });
}

getCategoryCount(type: string): number {
  return this.globalSearchResults.filter(
    (result) => result.type === type
  ).length;
}

getResultTypeLabel(
  type: SearchResultType
): string {
  const labels: Record<
    SearchResultType,
    string
  > = {
    job: 'Job',
    quotation: 'Quotation',
  };

  return labels[type];
}

getStatusClass(status: string): string {
  const normalized = this.normalize(status);

  if (
    normalized.includes('active') ||
    normalized.includes('posted') ||
    normalized.includes('completed')
  ) {
    return 'status-success';
  }

  if (
    normalized.includes('progress') ||
    normalized.includes('pending')
  ) {
    return 'status-warning';
  }

  if (
    normalized.includes('cancel') ||
    normalized.includes('blocked')
  ) {
    return 'status-danger';
  }

  return 'status-neutral';
}

highlightText(value: string): string {
  const query = this.searchQuery.trim();

  if (!query) {
    return this.escapeHtml(value);
  }

  const escapedValue = this.escapeHtml(value);
  const escapedQuery = query.replace(
    /[.*+?^${}()|[\]\\]/g,
    '\\$&'
  );

  return escapedValue.replace(
    new RegExp(`(${escapedQuery})`, 'gi'),
    '<mark>$1</mark>'
  );
}





private escapeHtml(value: string): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

@HostListener('document:keydown', ['$event'])
handleGlobalKeyboardShortcut(event: KeyboardEvent): void {
  const target = event.target as HTMLElement | null;

  const isTypingInsideControl =
    target?.tagName === 'INPUT' ||
    target?.tagName === 'TEXTAREA' ||
    target?.tagName === 'SELECT' ||
    target?.isContentEditable;

  const isSearchShortcut =
    (event.ctrlKey || event.metaKey) &&
    event.key.toLowerCase() === 'k';

  if (isSearchShortcut) {
    event.preventDefault();

    if (this.globalSearchOpen) {
      this.closeGlobalSearch();
    } else {
      this.openGlobalSearch();
    }

    return;
  }

  if (
    event.key === 'Escape' &&
    this.globalSearchOpen
  ) {
    event.preventDefault();
    this.closeGlobalSearch();
    return;
  }

  if (isTypingInsideControl || !this.globalSearchOpen) {
    return;
  }
}

// ___________ LEDGER _____________ //

private getFinancialNumber(
  ...values: unknown[]
): number {
  for (const value of values) {
    if (
      value === undefined ||
      value === null ||
      value === ''
    ) {
      continue;
    }

    const parsed =
      typeof value === 'string'
        ? Number(
            value
              .replace(/,/g, '')
              .trim()
          )
        : Number(value);

    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return 0;
}

private getLedgerCurrency(
  ledger: any
): string {
  return String(
    ledger?.baseCurrency ||
    ledger?.currency ||
    ledger?.invoiceCurrency ||
    ledger?.originalCurrency ||
    'PKR'
  )
    .trim()
    .toUpperCase();
}

private getLedgerInvoiceAmount(
  ledger: any
): {
  amount: number;
  currency: string;
} {
  const convertedAmount =
    this.getFinancialNumber(
      ledger?.convertedTotal,
      ledger?.convertedAmount,
      ledger?.totalPKR,
      ledger?.totalAmountPKR
    );

  if (convertedAmount) {
    return {
      amount: convertedAmount,
      currency: 'PKR',
    };
  }

  const originalAmount =
    this.getFinancialNumber(
      ledger?.originalTotal,
      ledger?.originalAmount,
      ledger?.totalAmount,
      ledger?.total,
      ledger?.baseAmount,
      ledger?.amount
    );

  return {
    amount: originalAmount,
    currency:
      this.getLedgerCurrency(ledger),
  };
}

private getLedgerBalanceAmount(
  ledger: any,
  invoiceTotal: number,
  currency: string
): number {
  if (currency === 'PKR') {
    const convertedBalance =
      this.getFinancialNumber(
        ledger?.convertedBalance,
        ledger?.balancePKR,
        ledger?.remainingPKR
      );

    if (convertedBalance) {
      return convertedBalance;
    }
  }

  const directBalance =
    this.getFinancialNumber(
      ledger?.balance,
      ledger?.remaining,
      ledger?.outstandingBalance,
      ledger?.balanceAmount
    );

  /*
   * Zero valid balance bhi ho sakta hai, lekin
   * first-number helper zero aur missing ko
   * distinguish nahi karta.
   */
  const hasDirectBalance = [
    ledger?.convertedBalance,
    ledger?.balancePKR,
    ledger?.remainingPKR,
    ledger?.balance,
    ledger?.remaining,
    ledger?.outstandingBalance,
    ledger?.balanceAmount,
  ].some(
    value =>
      value !== undefined &&
      value !== null &&
      value !== ''
  );

  if (hasDirectBalance) {
    return directBalance;
  }

  /*
   * Stored balance missing ho to invoice ka
   * complete amount outstanding assume hoga.
   */
  return invoiceTotal;
}

private getLedgerRecordKeys(
  ledger: any
): string[] {
  return this.uniqueStrings([
    ledger?.jobId,
    ledger?.jobKey,
    ledger?.jobNo,
    ledger?.jobNumber,
    ledger?.refNo,
    ledger?.referenceNo,
    ledger?.jobRef,
    ledger?.jobReference,

    ledger?.mblNo,
    ledger?.mblAwb,
    ledger?.awbNo,
    ledger?.mawbNo,

    ledger?.hblNo,
    ledger?.hblNumber,
    ledger?.hHawblNo,
    ledger?.hawbNo,

    ledger?.invoiceDetails?.jobId,
    ledger?.invoiceDetails?.jobNo,
    ledger?.invoiceDetails?.refNo,
    ledger?.invoiceDetails?.mblNo,
    ledger?.invoiceDetails?.hblNo,
  ])
    .map(value =>
      this.normalizeFinancialKey(value)
    )
    .filter(Boolean);
}

private getLedgerInvoiceIdentity(
  ledger: any,
  ledgerType: string,
  invoiceNumber: string,
  amount: number,
  currency: string
): string {
  return [
    ledgerType,
    invoiceNumber,
    ledger?.jobId,
    ledger?.jobNo,
    ledger?.refNo,
    ledger?.hblNo,
    ledger?.mblNo,
    currency,
    Number(amount || 0).toFixed(2),
  ]
    .map(value =>
      this.normalizeFinancialKey(value)
    )
    .filter(Boolean)
    .join('|');
}

private createEmptyJobLedgerSummary():
  JobLedgerSummary {
  return {
    invoices: [],
    invoiceNumbers: [],

    totalInvoiceCount: 0,
    receivableInvoiceCount: 0,
    payableInvoiceCount: 0,

    currencyTotals: {},
  };
}

private getOrCreateCurrencyTotals(
  summary: JobLedgerSummary,
  currency: string
): CurrencyFinancialTotals {
  const normalizedCurrency =
    String(currency || 'PKR')
      .trim()
      .toUpperCase();

  if (
    !summary.currencyTotals[
      normalizedCurrency
    ]
  ) {
    summary.currencyTotals[
      normalizedCurrency
    ] = {
      totalReceivable: 0,
      receivableBalance: 0,

      totalPayable: 0,
      payableBalance: 0,

      netBalance: 0,
    };
  }

  return summary.currencyTotals[
    normalizedCurrency
  ];
}

private buildJobLedgerSummaryCache():
  void {
  this.jobLedgerSummaryCache.clear();

  const ledgerRecords =
    this.globalDataCache.ledger || [];

  /*
   * Har Job-key ke andar duplicate invoice
   * identities track hongi.
   */
  const seenByKey =
    new Map<string, Set<string>>();

  for (const ledger of ledgerRecords) {
    if (
      !ledger ||
      ledger?.deleted === true ||
      ledger?.isOpeningBalance === true
    ) {
      continue;
    }

    const ledgerType =
      String(ledger?.type || '')
        .trim()
        .toLowerCase();

    if (
      ledgerType !== 'receivable' &&
      ledgerType !== 'payable'
    ) {
      continue;
    }

    /*
     * Customer receivable normal asset hai.
     * Payable record liability hai.
     *
     * Ledger report mein non-customer
     * receivable line/agent adjustment ho sakta
     * hai, lekin Job summary mein record ka
     * declared type respect karenge.
     */
    const recordKeys =
      this.getLedgerRecordKeys(
        ledger
      );

    if (!recordKeys.length) {
      continue;
    }

    const invoiceNumber =
      this.firstNonEmpty(
        ledger?.invoiceNo,
        ledger?.invoiceNumber,
        ledger?.invoiceId,
        ledger?.voucherNo,
        ledger?.id
      );

    const {
      amount: invoiceTotal,
      currency,
    } = this.getLedgerInvoiceAmount(
      ledger
    );

    const balance =
      this.getLedgerBalanceAmount(
        ledger,
        invoiceTotal,
        currency
      );

    const identity =
      this.getLedgerInvoiceIdentity(
        ledger,
        ledgerType,
        invoiceNumber,
        invoiceTotal,
        currency
      );

    const invoice: JobLedgerInvoice = {
      identity,
      invoiceNumber:
        invoiceNumber || 'Unnumbered',

      type:
        ledgerType as
          | 'receivable'
          | 'payable',

      currency,
      total: invoiceTotal,
      balance,

      hblNumber:
        this.firstNonEmpty(
          ledger?.hblNo,
          ledger?.hblNumber,
          ledger?.hHawblNo
        ),

      mblNumber:
        this.firstNonEmpty(
          ledger?.mblNo,
          ledger?.mblAwb,
          ledger?.awbNo
        ),

      partyName:
        this.firstNonEmpty(
          ledger?.customerName,
          ledger?.agentName,
          ledger?.lineName,
          ledger?.partyName,
          ledger?.vendorName,
          ledger?.payTo
        ),
    };

    for (
      const key of
      [...new Set(recordKeys)]
    ) {
      if (
        !this.jobLedgerSummaryCache.has(
          key
        )
      ) {
        this.jobLedgerSummaryCache.set(
          key,
          this.createEmptyJobLedgerSummary()
        );
      }

      if (!seenByKey.has(key)) {
        seenByKey.set(
          key,
          new Set<string>()
        );
      }

      const seen =
        seenByKey.get(key)!;

      if (seen.has(identity)) {
        continue;
      }

      seen.add(identity);

      const summary =
        this.jobLedgerSummaryCache.get(
          key
        )!;

      summary.invoices.push(invoice);

      if (
        invoiceNumber &&
        !summary.invoiceNumbers.includes(
          invoiceNumber
        )
      ) {
        summary.invoiceNumbers.push(
          invoiceNumber
        );
      }

      if (
        ledgerType === 'receivable'
      ) {
        summary.receivableInvoiceCount++;
      } else {
        summary.payableInvoiceCount++;
      }

      const totals =
        this.getOrCreateCurrencyTotals(
          summary,
          currency
        );

      if (
        ledgerType === 'receivable'
      ) {
        totals.totalReceivable +=
          invoiceTotal;

        totals.receivableBalance +=
          balance;
      } else {
        totals.totalPayable +=
          invoiceTotal;

        totals.payableBalance +=
          balance;
      }
    }
  }

  /*
   * Final counts aur currency-wise net
   * balances calculate karo.
   */
  for (
    const summary of
    this.jobLedgerSummaryCache.values()
  ) {
    summary.totalInvoiceCount =
      summary.invoices.length;

    Object.values(
      summary.currencyTotals
    ).forEach(totals => {
      totals.netBalance =
        totals.receivableBalance -
        totals.payableBalance;
    });
  }
}

private getJobFinancialKeys(
  id: string,
  job: any,
  jobNumber: string,
  master: any,
  houses: any[]
): string[] {
  return this.uniqueStrings([
    id,
    job?.id,
    job?.key,

    jobNumber,
    job?.jobId,
    job?.jobKey,
    job?.jobNo,
    job?.jobNumber,
    job?.refNo,
    job?.referenceNo,
    job?.manualRef,

    master?.jobId,
    master?.jobKey,
    master?.jobNo,
    master?.refNo,

    master?.mblNo,
    master?.mblAwb,
    master?.mbl,
    master?.awbNo,
    master?.awb,

    job?.mblNo,
    job?.mblAwb,
    job?.awbNo,

    ...(houses || []).flatMap(
      (house: any) => [
        house?.jobId,
        house?.jobKey,
        house?.jobNo,

        house?.hblNo,
        house?.hblNumber,
        house?.hHawblNo,
        house?.hbl,
        house?.houseBL,
        house?.houseBl,
        house?.hawbNo,
      ]
    ),
  ])
    .map(value =>
      this.normalizeFinancialKey(
        value
      )
    )
    .filter(Boolean);
}

private getJobLedgerSummary(
  id: string,
  job: any,
  jobNumber: string,
  master: any,
  houses: any[]
): JobLedgerSummary {
  const result =
    this.createEmptyJobLedgerSummary();

  const keys =
    this.getJobFinancialKeys(
      id,
      job,
      jobNumber,
      master,
      houses
    );

  const seenInvoices =
    new Set<string>();

  for (const key of keys) {
    const cached =
      this.jobLedgerSummaryCache.get(
        key
      );

    if (!cached) {
      continue;
    }

    for (
      const invoice of
      cached.invoices
    ) {
      if (
        seenInvoices.has(
          invoice.identity
        )
      ) {
        continue;
      }

      seenInvoices.add(
        invoice.identity
      );

      result.invoices.push(
        invoice
      );

      if (
        invoice.invoiceNumber &&
        invoice.invoiceNumber !==
          'Unnumbered' &&
        !result.invoiceNumbers.includes(
          invoice.invoiceNumber
        )
      ) {
        result.invoiceNumbers.push(
          invoice.invoiceNumber
        );
      }

      if (
        invoice.type === 'receivable'
      ) {
        result.receivableInvoiceCount++;
      } else {
        result.payableInvoiceCount++;
      }

      const totals =
        this.getOrCreateCurrencyTotals(
          result,
          invoice.currency
        );

      if (
        invoice.type === 'receivable'
      ) {
        totals.totalReceivable +=
          invoice.total;

        totals.receivableBalance +=
          invoice.balance;
      } else {
        totals.totalPayable +=
          invoice.total;

        totals.payableBalance +=
          invoice.balance;
      }
    }
  }

  result.totalInvoiceCount =
    result.invoices.length;

  Object.values(
    result.currencyTotals
  ).forEach(totals => {
    totals.netBalance =
      totals.receivableBalance -
      totals.payableBalance;
  });

  return result;
}

private formatLedgerCurrencyField(
  summary: JobLedgerSummary,
  field:
    | 'totalReceivable'
    | 'receivableBalance'
    | 'totalPayable'
    | 'payableBalance'
    | 'netBalance'
): string {
  return Object.entries(
    summary.currencyTotals
  )
    .filter(
      ([, totals]) =>
        Math.abs(
          Number(totals[field] || 0)
        ) > 0.0001
    )
    .map(
      ([currency, totals]) =>
        `${currency} ${Number(
          totals[field] || 0
        ).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
    )
    .join(' | ');
}

private formatLedgerCurrencyFieldOrZero(
  summary: JobLedgerSummary,
  field:
    | 'totalReceivable'
    | 'receivableBalance'
    | 'totalPayable'
    | 'payableBalance'
    | 'netBalance'
): string {
  return (
    this.formatLedgerCurrencyField(
      summary,
      field
    ) || 'PKR 0.00'
  );
}



private buildJobRoute(
  documentId: string,
  job: Record<string, any>
): string {
  const direction = this.normalize(
    job.direction ||
    job.shipmentDirection ||
    job.jobData?.direction ||
    ''
  );

  const source = this.normalize(
    job.source ||
    job.jobData?.source ||
    ''
  );

  const quotationKey = String(
    job.quotationKey ||
    job.quotationId ||
    job.jobData?.quotationKey ||
    ''
  ).trim();

  if (source === 'booking') {
    return quotationKey
      ? `/pages/house-details/${documentId}/${quotationKey}`
      : `/pages/house-details/${documentId}`;
  }

  if (direction === 'import') {
    return `/pages/operations/import-mbl/${documentId}`;
  }

  if (direction === 'export') {
    return `/pages/operations/export-mbl/${documentId}`;
  }

  return '/pages/operations/view-bls';
}


}
